export const action = type => Object.assign(
  payload => ({ type, payload }),
  { type }
);




// WEBPACK FOOTER //
// ./src/redux-utils/actions.js